export default __webpack_public_path__ + "static/media/devpool.bc2efeba.jpg";